export default  [

// Classic
 {
   "Emoji": "😀",
   "SentimentScore": 0.568,
   "Category": "Classic"
 },
 {
   "Emoji": "🙂",
   "SentimentScore": null,
   "Category": "Classic"
 },
 {
   "Emoji": "😐",
   "SentimentScore": -0.388,
   "Category": "Classic"
 },
 {
   "Emoji": "😡",
   "SentimentScore": -0.173,
   "Category": "Classic"
 },

 // Happy
 {
   "Emoji": "😀",
   "SentimentScore": 0.568,
   "Category": "Happy"
 },
 {
   "Emoji": "😁",
   "SentimentScore": 0.449,
   "Category": "Happy"
 },
 {
   "Emoji": "😄",
   "SentimentScore": 0.421,
   "Category": "Happy"
 },
 {
   "Emoji": "😊",
   "SentimentScore": 0.644,
   "Category": "Happy"
 },
 {
   "Emoji": "😌",
   "SentimentScore": 0.482,
   "Category": "Happy"
 },
 {
   "Emoji": "🌈",
   "SentimentScore": 0.516,
   "Category": "Happy"
 },
 {
   "Emoji": "👍",
   "SentimentScore": 0.521,
   "Category": "Happy"
 },
 {
   "Emoji": "🎉",
   "SentimentScore": 0.738,
   "Category": "Happy"
 },
 {
   "Emoji": "🤩",
   "SentimentScore": 0,
   "Category": "Happy"
 },
 {
   "Emoji": "🙃",
   "SentimentScore": null,
   "Category": "Happy"
 },
   {"Emoji": "🌸",
   "SentimentScore": 0.65,
   "Category": "Happy"
 },
  { "Emoji": "🌻",
   "SentimentScore": 0.57,
   "Category": "Happy"
 },
   {"Emoji": "🌷",
   "SentimentScore": 0.538,
   "Category": "Happy"
 },
 {
   "Emoji": "😎",
   "SentimentScore": 0.491,
   "Category": "Happy"
 },
 {
   "Emoji": "🥰",
   "SentimentScore": 0.68,
   "Category": "Happy"
 },
 {
   "Emoji": "😍",
   "SentimentScore": 0.678,
   "Category": "Happy"
 },
 {
   "Emoji": "💃🏻",
   "SentimentScore": 0.734,
   "Category": "Happy"
 },
 {
   "Emoji": "🕺🏽",
   "SentimentScore": 0.734,
   "Category": "Happy"
 },
 {
   "Emoji": "🌼",
   "SentimentScore": 0.779,
   "Category": "Happy"
 },
 {
 "Emoji": "✨",
 "SentimentScore": 0.7,
 "Category": "Happy",
 "Premium": "true"
},

 // Sad
 {
   "Emoji": "😭",
   "SentimentScore": -0.093,
   "Category": "Sad"
 },
 {
   "Emoji": "😔",
   "SentimentScore": -0.146,
   "Category": "Sad"
 },
 {
   "Emoji": "😞",
   "SentimentScore": -0.118,
   "Category": "Sad"
 },
 {
   "Emoji": "😢",
   "SentimentScore": 0.007,
   "Category": "Sad"
 },
 {
   "Emoji": "😩",
   "SentimentScore": -0.368,
   "Category": "Sad"
 },
 {
   "Emoji": "😫",
   "SentimentScore": -0.145,
   "Category": "Sad"
 },
 {
   "Emoji": "😟",
   "SentimentScore": 0.072,
   "Category": "Sad"
 },
 {
   "Emoji": "😥",
   "SentimentScore": 0.122,
   "Category": "Sad"
 },
 {
   "Emoji": "💔",
   "SentimentScore": -0.121,
   "Category": "Sad"
 },
 {
   "Emoji": "😐",
   "SentimentScore": -0.388,
   "Category": "Sad"
 },

 // Stressed
 {
   "Emoji": "😥",
   "SentimentScore": 0.122,
   "Category": "Stressed"
 },
 {
   "Emoji": "😓",
   "SentimentScore": -0.08,
   "Category": "Stressed"
 },
 {
   "Emoji": "😬",
   "SentimentScore": 0.194,
   "Category": "Stressed"
 },
 {
   "Emoji": "😿",
   "SentimentScore": -0.372,
   "Category": "Stressed"
 },
 {
   "Emoji": "😅",
   "SentimentScore": 0.178,
   "Category": "Stressed"
 },
 {
   "Emoji": "🤯",
   "SentimentScore": null,
   "Category": "Stressed"
 },
//  {
//    "Emoji": "😁",
//    "SentimentScore": 0.449,
//    "Category": "Stressed"
//  },
 {
   "Emoji": "💥",
   "SentimentScore": 0.148,
   "Category": "Stressed"
 },
 // {
 //   "Emoji": "😞",
 //   "SentimentScore": -0.118,
 //   "Category": "Stressed"
 // },
 {
   "Emoji": "🚨",
   "SentimentScore": 0.638,
   "Category": "Stressed"
 },
 {
   "Emoji": "🥊",
   "SentimentScore": null,
   "Category": "Stressed"
 },
 {
   "Emoji": "🌋",
   "SentimentScore": 0.444,
   "Category": "Stressed"
 },
 {
   "Emoji": "🏃",
   "SentimentScore": 0.406,
   "Category": "Busy"
 }, {
   "Emoji": "🤹🏻‍♀️",
   "SentimentScore": 0.1,
   "Category": "Busy"
 },
 {
   "Emoji": "📅",
   "SentimentScore": 0.167,
   "Category": "Busy"
 },
 {
   "Emoji": "🥵",
   "SentimentScore": null,
   "Category": "Busy"
 },
 {
   "Emoji": "☎️",
   "SentimentScore": 0,
   "Category": "Busy"
 },
 {
   "Emoji": "💻",
   "SentimentScore": 0.25,
   "Category": "Busy"
 },
 {
   "Emoji": "🏃🏾‍♀️",
   "SentimentScore": null,
   "Category": "Busy"
 },
 {
   "Emoji": "😫",
   "SentimentScore": -0.145,
   "Category": "Busy"
 },
 {
   "Emoji": "⏱",
   "SentimentScore": 0.11,
   "Category": "Busy"
 },
 {
   "Emoji": "📘",
   "SentimentScore": 0.11,
   "Category": "Busy"
 },
 // {
 //   "Emoji": "💤",
 //   "SentimentScore": 0.37,
 //   "Category": "Tired"
 // },
 {
   "Emoji": "🥱",
   "SentimentScore": null,
   "Category": "Tired"
 },
 {
   "Emoji": "😴",
   "SentimentScore": -0.08,
   "Category": "Tired"
 },
 {
   "Emoji": "😫",
   "SentimentScore": -0.145,
   "Category": "Tired"
 },
 {
   "Emoji": "🛏️",
   "SentimentScore": null,
   "Category": "Tired"
 },
 {
   "Emoji": "☕️",
   "SentimentScore": 0.244,
   "Category": "Tired"
 },
 {
   "Emoji": "🪫",
   "SentimentScore": -0.2,
   "Category": "Tired"
 },
 {
   "Emoji": "😡",
   "SentimentScore": -0.173,
   "Category": "Angry"
 },
 {
   "Emoji": "😤",
   "SentimentScore": -0.209,
   "Category": "Angry"
 },
 {
   "Emoji": "💢",
   "SentimentScore": 0.233,
   "Category": "Angry"
 },
 {
   "Emoji": "👿",
   "SentimentScore": -0.534,
   "Category": "Angry"
 },
 {
   "Emoji": "😒",
   "SentimentScore": -0.374,
   "Category": "Angry"
 },
 {
   "Emoji": "😾",
   "SentimentScore": -0.333,
   "Category": "Angry"
 },
 {
   "Emoji": "😠",
   "SentimentScore": -0.299,
   "Category": "Angry"
 },
 {
   "Emoji": "😰",
   "SentimentScore": -0.02,
   "Category": "Worried"
 },
 {
   "Emoji": "🥺",
   "SentimentScore": null,
   "Category": "Worried"
 },
 {
   "Emoji": "👀",
   "SentimentScore": 0.063,
   "Category": "Worried"
 },
 {
   "Emoji": "😟",
   "SentimentScore": 0.072,
   "Category": "Worried"
 },
 {
   "Emoji": "😬",
   "SentimentScore": 0.194,
   "Category": "Worried"
 },
 {
   "Emoji": "😩",
   "SentimentScore": -0.368,
   "Category": "Worried"
 },
 {
   "Emoji": "🙄",
   "SentimentScore": null,
   "Category": "Worried"
 },
 {
   "Emoji": "🤩",
   "SentimentScore": 0.75,
   "Category": "Excited"
 },
 {
   "Emoji": "🤪",
   "SentimentScore": 0.75,
   "Category": "Excited"
 },
 {
   "Emoji": "🤠",
   "SentimentScore": 0.75,
   "Category": "Excited"
 },
 {
   "Emoji": "⛱️",
   "SentimentScore": null,
   "Category": "Holiday"
 },
 {
   "Emoji": "✈️",
   "SentimentScore": 0.415,
   "Category": "Holiday"
 },
 {
   "Emoji": "🌴",
   "SentimentScore": 0.525,
   "Category": "Holiday"
 },
 {
   "Emoji": "☀️",
   "SentimentScore": 0.465,
   "Category": "Holiday"
 },
 {
   "Emoji": "🏖",
   "SentimentScore": null,
   "Category": "Holiday"
 },
 {
   "Emoji": "😎",
   "SentimentScore": 0.491,
   "Category": "Holiday"
 },
 {
   "Emoji": "🌇",
   "SentimentScore": 0.5,
   "Category": "Holiday"
 },
 {
   "Emoji": "🤒",
   "SentimentScore": null,
   "Category": "Unwell"
 },
 {
   "Emoji": "🤢",
   "SentimentScore": null,
   "Category": "Unwell"
 },
 {
   "Emoji": "😷",
   "SentimentScore": -0.169,
   "Category": "Unwell"
 },
 {
   "Emoji": "🥴",
   "SentimentScore": null,
   "Category": "Unwell"
 },
 {
   "Emoji": "🤕",
   "SentimentScore": null,
   "Category": "Unwell"
 },
 {
   "Emoji": "😫",
   "SentimentScore": -0.145,
   "Category": "Unwell"
 },
 {
   "Emoji": "🤧",
   "SentimentScore": null,
   "Category": "Unwell"
 },
 {
   "Emoji": "🌡️",
   "SentimentScore": 0.6,
   "Category": "Hot"
 },
 {
   "Emoji": "☀️",
   "SentimentScore": 0.6,
   "Category": "Hot"
 },
 {
   "Emoji": "🥵",
   "SentimentScore": 0.4,
   "Category": "Hot"
 },
 {
   "Emoji": "🌶️",
   "SentimentScore": 0.139,
   "Category": "Hot"
 },
 {
   "Emoji": "🌭",
   "SentimentScore": 0.65,
   "Category": "Hot"
 },
 {
   "Emoji": "🔥",
   "SentimentScore": 0.139,
   "Category": "Hot"
 },
 {
   "Emoji": "🥶",
   "SentimentScore": -0.1,
   "Category": "Cold"
 },
 {
   "Emoji": "❄️",
   "SentimentScore": 0.1,
   "Category": "Cold"
 },
 {
   "Emoji": "☃️",
   "SentimentScore": 0.2,
   "Category": "Cold"
 },
 {
   "Emoji": "🧊",
   "SentimentScore": 0.1,
   "Category": "Cold"
 },

 // Winning
 {
   "Emoji": "🙌",
   "SentimentScore": 0.559,
   "Category": "Winning"
 },
 {
   "Emoji": "🚀",
   "SentimentScore": 0.488,
   "Category": "Winning"
 },
 {
   "Emoji": "🏆",
   "SentimentScore": 0.726,
   "Category": "Winning"
 },
 {
   "Emoji": "🥇",
   "SentimentScore": 0.6,
   "Category": "Winning"
 },
 {
   "Emoji": "🥈",
   "SentimentScore": 0.5,
   "Category": "Winning"
 },
 {
   "Emoji": "🥉",
   "SentimentScore": 0.4,
   "Category": "Winning"
 },
 {
   "Emoji": "✌🏾",
   "SentimentScore": 0.488,
   "Category": "Winning"
 },
 // {
 //   "Emoji": "💲",
 //   "SentimentScore": 0.242,
 //   "Category": "Winning"
 // },
 {
   "Emoji": "💵",
   "SentimentScore": 0.379,
   "Category": "Winning"
 },
 {
   "Emoji": "🥅",
   "SentimentScore": 0.5,
   "Category": "Winning"
 },
 {
   "Emoji": "📈",
   "SentimentScore": 0.5,
   "Category": "Winning"
 },

 // Stuck or Blocked
 {
   "Emoji": "🛑",
   "SentimentScore": -0.1,
   "Category": "Stuck or Blocked"
 },
 {
   "Emoji": " 🚫",
   "SentimentScore": -0.44,
   "Category": "Stuck or Blocked"
 },
 {
   "Emoji": " ⏳",
   "SentimentScore": 0,
   "Category": "Stuck or Blocked"
 },
 {
   "Emoji": "🐌",
   "SentimentScore": 0.647,
   "Category": "Stuck or Blocked"
 },
 {
   "Emoji": "😫",
   "SentimentScore": -0.145,
   "Category": "Stuck or Blocked"
 }, 
 {
   "Emoji": "🐢",
   "SentimentScore": 0.2,
   "Category": "Stuck or Blocked"
 }, 
 {
   "Emoji": "🆘",
   "SentimentScore": 0.071,
   "Category": "Stuck or Blocked"
 }, 

 // Problem Solved
 {
   "Emoji": "🤓",
   "SentimentScore": 0.5,
   "Category": "Problem Solved!"
 },
 {
   "Emoji": "😌",
   "SentimentScore": 0.482,
   "Category": "Problem Solved!"
 },
 {
   "Emoji": "💡",
   "SentimentScore": 0.6,
   "Category": "Problem Solved!"
 },
 {
   "Emoji": "🔧",
   "SentimentScore": 0.55,
   "Category": "Problem Solved!"
 },
 {
   "Emoji": "🛠️",
   "SentimentScore": 0.55,
   "Category": "Problem Solved!"
 },
 {
   "Emoji": "⛏️",
   "SentimentScore": 0.55,
   "Category": "Problem Solved!"
 }, {
   "Emoji": "✅",
   "SentimentScore": 0.407,
   "Category": "Problem Solved!"
 },


// Celebrating
 {
   "Emoji": "🎁",
   "SentimentScore": 0.759,
   "Category": "Celebrating"
 },
 {
   "Emoji": "🎉",
   "SentimentScore": 0.738,
   "Category": "Celebrating"
 },
 {
   "Emoji": "🎊",
   "SentimentScore": 0.721,
   "Category": "Celebrating"
 },
 {
   "Emoji": "🎂",
   "SentimentScore": 0.613,
   "Category": "Celebrating"
 },
 {
   "Emoji": "💍",
   "SentimentScore": 0.478,
   "Category": "Celebrating"
 },
 {
   "Emoji": "🥂",
   "SentimentScore": 0.511,
   "Category": "Celebrating"
 },
 {
   "Emoji": "🍾",
   "SentimentScore": 0.511,
   "Category": "Celebrating"
 },
 {
   "Emoji": "🥳",
   "SentimentScore": 0.511,
   "Category": "Celebrating"
 },
 {
   "Emoji": "🚀",
   "SentimentScore": 0.488,
   "Category": "Celebrating"
 },

 // Monday
 {
   "Emoji": "Ⓜ️",
   "SentimentScore": 0.25,
   "Category": "It's Monday!"
 },  {
   "Emoji": "😃",
   "SentimentScore": 0.557,
   "Category": "It's Monday!"
 }, 
 {
   "Emoji": "😭",
   "SentimentScore": -0.093,
   "Category": "It's Monday!"
 },
  {
   "Emoji": "😖",
   "SentimentScore": -0.155,
   "Category": "It's Monday!"
 }
// Chilled
 ,
  {
   "Emoji": "🧊",
   "SentimentScore": 0.55,
   "Category": "Chilled",
   "Premium": "true"
 },
 {
  "Emoji": "😌",
  "SentimentScore": 0.482,
  "Category": "Chilled",
  "Premium": "true"
},
{
 "Emoji": "🏄🏻‍♀️",
 "SentimentScore": 0.524,
 "Category": "Chilled",
 "Premium": "true"
},
{
 "Emoji": "🛋️",
 "SentimentScore": 0.55,
 "Category": "Chilled"
},
{
 "Emoji": "🧘‍♀️",
 "SentimentScore": 0.55,
 "Category": "Chilled"
},
// Confused or Lost
{
 "Emoji": "😶‍🌫️",
 "SentimentScore": -0.142,
 "Category": "Confused or Lost"
},
{
  "Emoji": "🌫️",
  "SentimentScore": -0.4,
  "Category": "Confused or Lost"
 },
{
  "Emoji": "🌀",
  "SentimentScore": 0.101,
  "Category": "Confused or Lost"
 },
 // Creative 
{
  "Emoji": "💫",
  "SentimentScore": 0.5,
  "Category": "Creative",
  "Premium": "true"
 },
{
  "Emoji": "🎨",
  "SentimentScore": 0.167,
  "Category": "Creative",
  "Premium": "true"
 },
{
  "Emoji": "🌠",
  "SentimentScore": 0.529,
  "Category": "Creative",
  "Premium": "true"
 },
 // Challenged
{
  "Emoji": "🧗🏽‍♂️",
  "SentimentScore": 0.125,
  "Category": "Challenged",
  "Premium": "true"
 },
{
  "Emoji": "🏋️",
  "SentimentScore": 0.125,
  "Category": "Challenged",
  "Premium": "true"
 },
// Inspired
{
  "Emoji": "🗺️",
  "SentimentScore": 0.5,
  "Category": "Inspired",
  "Premium": "true"
 }
]
